"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.PERSONALISATION;
var options = ["Learn mental fitness skills", "Build better habits", "Change my beliefs", "Mental health", "Helping Others with Mental Health", "Better sleep", "Stress or Worry", "Relationships", "Health", "Career", "Alcohol, Gambling or Addictions"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  options: options
};
var personaliseQuestions = [{
  prompt: "What can we help you with?",
  options: options,
  meta: {
    answerLabel: "I need help with...",
    skipLabel: "No help required",
    responsePrefix: "I need help with: ",
    noResponsePrefix: "I don't need help with anything at the moment"
  },
  aggregated: true,
  key: "personalisation",
  type: "multiSkip",
  specific: true,
  batteryId: batteryId,
  eval: function _eval(n) {
    return n;
  }
}];
var questions = (0, _utils.wrapBattery)(personaliseQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  return answers;
}